import { IUserMonitoring, IRUMMgr, RUMEventData, IRUMUserDataProvider } from '@nab/x-types';
import { sdkLoggerInterface } from '../Logger/Logger';

export class UserMonitoring implements IUserMonitoring {
    constructor(private appId: string, private rumMgr: IRUMMgr) {}

    /**
     * emitRUMEvent The Event you would want to send based on the defined strategies
     */
    public emitRUMEvent(eventData: RUMEventData): void {
        if (this.rumMgr) {
            this.rumMgr.emitEvent(this.appId, eventData);
        } else {
            sdkLoggerInterface.warn('Failed to emit RUM Event. Rum Manager is not initialised.');
        }
    }

    /**
     * setUserDataProvider... This allows miniapp teams to provide additional context / information to the rum event when being sent to rum provider / strategy.
     */
    public setRUMUserDataProvider(userDataProvider: IRUMUserDataProvider): void {
        if (this.rumMgr) {
            this.rumMgr.setUserDataProvider(this.appId, userDataProvider);
        } else {
            sdkLoggerInterface.warn('Failed to set the user data provider. Rum Manager is not initialised.');
        }
    }
}
